module.exports = __webpack_public_path__ + "static/img/14003016.8455edd5.png";